<template>
    <footer class="footer">
        <div class="content has-text-centered">
            <p class="pa-0 ma-0">
                © <a href="https://lk.mizaem.ru/admin-login">Mizaem.ru</a> Отправка сообщений, 2023
            </p>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'Footer',
    };
</script>

<style>
    .footer {
        background-color: #ffffff;
        border-top: solid 1px #e4e4e4;
    }
</style>
